import { render, staticRenderFns } from "./flex.vue?vue&type=template&id=8f2f860e&scoped=true&"
import script from "./flex.vue?vue&type=script&lang=js&"
export * from "./flex.vue?vue&type=script&lang=js&"
import style0 from "./flex.vue?vue&type=style&index=0&id=8f2f860e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2f860e",
  null
  
)

export default component.exports